import React, { useState } from 'react'
import {v4} from "uuid"
import {IoMdAdd} from "react-icons/io"
import {FiMinus} from "react-icons/fi"
import styles from "./project.module.css"
import {AiOutlineDown, AiOutlineRight} from "react-icons/ai"
import { updatePost } from '../../utils/Fetch/fetch';
import { toast } from 'react-toastify'
import Loader from '../Loader/loader'

const Projects = () => {
    const [color, setColor] = useState(false)
    const [show, setShow] = useState(false)
    const [inputs, setInputs] = useState([
        {projectName:"", github:"", deployment:"",video:"", shortDesc:"", fea1:"", fea2:"",fea3:"", techstacks:"HTML | CSS | JAVASCRIPT", id:v4()},
    ])
        const [showLoader, setShowLoader] = useState(false);

    const handleChange = (event, id) => {
        let newInputs = inputs.map((el) => {
            if(el.id === id) {
                el[event.target.name] = event.target.value
            }
            return el;
        })

        setInputs(newInputs)
    }

    const handleAddInput = () => {
        if(inputs.length > 2){
            toast("Sorry! only 2 descriptive projects are allowed")
            return;
        }
        setInputs([...inputs,
            {projectName:"", github:"", deployment:"",video:"", shortDesc:"", fea1:"", fea2:"",fea3:"", techstacks:"HTML | CSS | JAVASCRIPT", id:v4()} ])
        
    }

    const handleMinusInput = (index) =>{
        const values  = [...inputs];
        values.splice(index, 1)
        setInputs(values)
    }

    const handleSave = async ()=> {
setShowLoader(true);
        let flag = false
        inputs.forEach((el) => {
          if(el.projectName==="" || el.github==="" || el.deployment==="" ||
          el.video==="" || el.shortDesc==="" || el.fea1==="" || el.fea2==="" || el.fea3==="" || el.techstacks===""
          ){
            flag = true;
          }
        })

        if(flag){
          toast("Please fill the empty project input feilds")
          setColor(false)
          setShowLoader(false);
          return;
        }
        let payload = inputs.map((el) => {
          return {projectName:el.projectName, github:el.github, deployment:el.deployment,video:el.video, shortDesc:el.shortDesc, fea1:el.fea1, fea2:el.fea2,fea3:el.fea3, techstacks:el.techstacks}
        })
        const updatedata = async () => {
          let data = await updatePost(JSON.stringify({projects: payload}))
          return data;
        }
  
        let updatedData = await updatedata()
  
        if(updatedData.success===true){
          toast("Project data is saved successfully!")
          setColor(true)
          setShow(false)
          setShowLoader(false);
        }else {
          toast("Something went wrong!")
          setShowLoader(false);
        }
  
  
  
      }

  return (
    <div>
       <nav className={styles.profile__nav} onClick={() => setShow(!show)}>
        <h3 style={{color : color===false ? "crimson" : 'grey'}}>
          Projects</h3>
        <span>
          {show ? <span className={styles.updown__icon}><AiOutlineDown/></span> : <span className={styles.updown__icon}><AiOutlineRight/></span>}
        </span>
      </nav>
      {
            show && <div className={styles.input__box}>
        {
            inputs.map((input, index) => (
                <div key={input.id} className={styles.inputs}>
                    <input type="text" name='projectName' placeholder='Enter your project name' value={input.projectName} 
                    onChange={(event) => handleChange(event, input.id)}/>

                    <input type="text" name='github' placeholder='Enter project github link' value={input.github} 
                    onChange={(event) => handleChange(event, input.id)}/>

                    <input type="text" name='deployment' placeholder='Enter project deployment link' value={input.deployment} 
                    onChange={(event) => handleChange(event, input.id)}/>

                    <input type="text" name='video' placeholder='Enter project video link' value={input.video} 
                    onChange={(event) => handleChange(event, input.id)}/>

                    <input type="text" name='shortDesc' placeholder='Enter project short description' value={input.shortDesc} 
                    onChange={(event) => handleChange(event, input.id)}/>

                    <input type="text" name='fea1' placeholder='Enter project feature' value={input.fea1} 
                    onChange={(event) => handleChange(event, input.id)}/>

                    <input type="text" name='fea2' placeholder='Enter project feature' value={input.fea2} 
                    onChange={(event) => handleChange(event, input.id)}/>

                    <input type="text" name='fea3' placeholder='Enter project feature' value={input.fea3} 
                    onChange={(event) => handleChange(event, input.id)}/>

                    <textarea name='techstacks' placeholder='HTML | CSS | JAVASCRIPT' value={input.techstacks}
                    onChange={(event) => handleChange(event, input.id)}/>
                <div style={{paddingTop:"10px"}}>
                <button onClick={() => handleAddInput()} style={{verticalAlign:"middle"}}>
                <IoMdAdd />
                </button>
                {
                    index >= 1 && <button onClick={() => handleMinusInput(index)} style={{verticalAlign:"middle", marginLeft:"5px"}}>
                        <FiMinus />
                    </button>
                }
                </div>

                </div>
            ))
        }
                <div className={styles.savebtn_box}>
                    <button onClick={handleSave}>Save</button>
                </div>
            </div>
        }
        {showLoader && <Loader /> }
    </div>
  )
}

export default Projects